import { render, staticRenderFns } from "./TradeOrders.vue?vue&type=template&id=02c42b27&scoped=true&"
import script from "./TradeOrders.vue?vue&type=script&lang=js&"
export * from "./TradeOrders.vue?vue&type=script&lang=js&"
import style0 from "./TradeOrders.vue?vue&type=style&index=0&id=02c42b27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c42b27",
  null
  
)

export default component.exports